#@import Booking.Presenters.Info
#@import Booking.Views.Base
#@export Booking.Views.Info

class Booking.Views.Info extends Booking.Views.Base

  presenter: Booking.Presenters.Info

  templateName: 'info'

  canRender: -> false
